import {ColumnType, FilterableColumn} from 'src/tracker/model/column/tracker-column'
import { nameProperty } from '../../property/static/name-property'

export const firstColumn = new FilterableColumn<string>(
  "210px",
  ColumnType.NAME,
  nameProperty,
)
